<div class="container pb-3" id="centerFrame">

  @if (id_perfil != 2) {
    <div class="fade-in">
      <div class="row row ps-3 pe-2 pt-2 mb-3">
        @if (id_perfil == 1) {
          <div class="col-8 home-title-left">Bienvenido <br> <b style="font-weight:600">Al panel de Administración</b></div>
        }
        @if (id_perfil == 3) {
          <div class="col-8 home-title-left">Bienvenido <br> <b style="font-weight:600">A tu panel</b></div>
        }
        @if (id_perfil == 4) {
          <div class="col-8 home-title-left">Bienvenido <br> <b style="font-weight:600">A tu panel</b></div>
        }

        <div class="col-4 home-title-right">
          <div class="col header-right-img me-2 mt-4">
            <a [routerLink]="['/my-account']">
              <img [src]="preview_img_avatar == '' ? './assets/img/user-init.png' : preview_img_avatar" style="width:100%" class="text-end rounded-circle business-profile">
            </a>
          </div>
        </div>
      </div>

      @if (showNotifications && !loading()) {
        <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" (click)="subscribeToNotifications()">
          <div class="row align-items-center p-2 p-sm-3 ms-2 me-2">
            <div class="col-auto parpadea"><i class="bi bi-bell-fill"></i></div>
            <div class="col alerts-row-text">
              <div class="alerts-row-text-title">ACTIVAR LAS NOTIFICACIONES</div>
              <div class="alerts-row-text-description">Para que puedas recibir las novedades</div>
            </div>
            <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
          </div>
        </div>
      }

      @if (error()) {
        <div class="alert alert-danger mt-4" role="alert">
          <small>{{ error() }}</small>
        </div>
      }
    </div>
  }

  <!-- INICIO ADMIINISTRADOR -->
  @if (id_perfil == 1) {
    <div class="fade-in header-search-home pb-0">
      <div class="row mb-4 row-col-row">
        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>COBROS</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{ingresosMesVigente | currency:'ARS'}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(ingresosMesVigente, ingresosMesAnterior) >= 0, 'no-growth': calcularCrecimiento(ingresosMesVigente, ingresosMesAnterior) < 0}">
              {{calcularCrecimiento(ingresosMesVigente, ingresosMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>

        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>RESERVAS</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{reservasMesVigente}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(reservasMesVigente, reservasMesAnterior) >= 0, 'no-growth': calcularCrecimiento(reservasMesVigente, reservasMesAnterior) < 0}">
              {{calcularCrecimiento(reservasMesVigente, reservasMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>

        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>PEDIDOS</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{pedidosMesVigente}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(pedidosMesVigente, pedidosMesAnterior) >= 0, 'no-growth': calcularCrecimiento(pedidosMesVigente, pedidosMesAnterior) < 0}">
              {{calcularCrecimiento(pedidosMesVigente, pedidosMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>

        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>USUARIOS</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{cantidadClientesMesVigente}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(cantidadClientesMesVigente, cantidadClientesMesAnterior) >= 0, 'no-growth': calcularCrecimiento(cantidadClientesMesVigente, cantidadClientesMesAnterior) < 0}">
              {{calcularCrecimiento(cantidadClientesMesVigente, cantidadClientesMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>

        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>PRESTADORES</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{cantidadPrestadoresMesVigente}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(cantidadPrestadoresMesVigente, cantidadPrestadoresMesAnterior) >= 0, 'no-growth': calcularCrecimiento(cantidadPrestadoresMesVigente, cantidadPrestadoresMesAnterior) < 0}">
              {{calcularCrecimiento(cantidadPrestadoresMesVigente, cantidadPrestadoresMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>

        <div class="statistics-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>COMERCIOS</span>
            <span>{{firstDay | date: 'd MMM'}} - {{lastDay | date: 'd MMM'}}</span>
          </div>
          <div class="card-body">
            <div class="amount">{{cantidadComerciosMesVigente}}</div>
            <div [ngClass]="{'growth': calcularCrecimiento(cantidadComerciosMesVigente, cantidadComerciosMesAnterior) >= 0, 'no-growth': calcularCrecimiento(cantidadComerciosMesVigente, cantidadComerciosMesAnterior) < 0}">
              {{calcularCrecimiento(cantidadComerciosMesVigente, cantidadComerciosMesAnterior).toFixed(2)}}% <span class="growth-text">desde el mes pasado</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4 mb-4 row-col-row">
        <div class="country-card col-12 col-md-6 col-lg-6">
          <h3 class="titles">Mejores Prestadores</h3>
          @if (mejoresPrestadores.length > 0) {
            @for (mejorPrestador of mejoresPrestadores; track mejorPrestador.id; let i = $index) {
              <ul class="country-list" [routerLink]="['/more-edit-prestador/' + mejorPrestador.id]">
                <li class="country-item cursor-pointer">
                  <div class="country-info">
                    <img class="title-image-user rounded-circle business-profile" 
                        [src]="mejorPrestador.x_img_avatar != null ? apiUri + 'uploads/images/small-' + mejorPrestador.x_img_avatar : './assets/img/profesional-init.png'" 
                        (error)="imgFallback($event, './assets/img/profesional-init.png')"
                        style="width: 30px !important;height: 30px !important;border-radius: 40px !important;">
                    <span class="country-name">{{(mejorPrestador.x_nombre || mejorPrestador.x_apellido) ? mejorPrestador.x_nombre + ' ' + mejorPrestador.x_apellido : 'Sin datos' }}</span>
                  </div>
                  <div class="country-stats">
                    <div class="sales">Ventas: <strong>{{ mejorPrestador.total_ordenes || 0 }}</strong></div>
                    <div class="bounce">Ranking: <strong>{{ i + 1 }}</strong></div>
                  </div>
                </li>
              </ul>
            }
          } @else {
            <p>Sin resultados</p>
          }
        </div>

        <div class="country-card col-12 col-md-6 col-lg-6">
          <h3 class="titles">Mejores Comercios</h3>
          @if (mejoresComercios.length > 0) {
            @for (mejorComercio of mejoresComercios; track mejorComercio.id; let i = $index) {
              <ul class="country-list" [routerLink]="['/more-edit-comercio/' + mejorComercio.id]">
                <li class="country-item cursor-pointer">
                  <div class="country-info">
                    <img class="title-image-user rounded-circle business-profile" 
                        [src]="mejorComercio.x_img_avatar != null ? apiUri + 'uploads/images/small-' + mejorComercio.x_img_avatar : './assets/img/profesional-init.png'" 
                        (error)="imgFallback($event, './assets/img/profesional-init.png')"
                        style="width: 30px !important;height: 30px !important;border-radius: 40px !important;">
                    <span class="country-name">{{ mejorComercio.x_nombre_fantasia ? mejorComercio.x_nombre_fantasia : 'Sin datos' }}</span>
                  </div>
                  <div class="country-stats">
                    <div class="sales">Ventas: <strong>{{ mejorComercio.total_ordenes || 0 }}</strong></div>
                    <div class="bounce">Ranking: <strong>{{ i + 1 }}</strong></div>
                  </div>
                </li>
              </ul>
            }
          } @else {
            <p>Sin resultados</p>
          }
        </div>
      </div>

      <div class="row mt-4 mb-4 row-col-row">
        <div class="product-card col-12 col-md-6 col-lg-6">
          <h3 class="titles">Productos mas vendidos</h3>
          <table class="table">
            <thead>
              <tr>
                <th>PRODUCTO</th>
                <th>PRECIO</th>
              </tr>
            </thead>
            <tbody>
              @for (productoMasVendido of productosMasVendidos; track productoMasVendido.id ?? $index) {
                <tr>
                  <td>
                    <div class="product">
                      <img 
                        [src]="productoMasVendido.x_img_producto ? apiUri + 'uploads/images/' + productoMasVendido.x_img_producto : './assets/img/no-image.png'"
                        (error)="imgFallback($event, './assets/img/no-image.png')">
                      <div class="product-info">
                        <span class="product-name">{{productoMasVendido.x_nombre}}</span>
                        <span class="orders">Cant. vendidos: {{productoMasVendido.total_vendido}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="value">{{productoMasVendido.precio | currency:'ARS'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="product-card col-12 col-md-6 col-lg-6">
          <h3 class="titles">Medicamentos mas vendidos</h3>
          <table class="table">
            <thead>
              <tr>
                <th>MEDICAMENTO</th>
                <th>PRECIO</th>
              </tr>
            </thead>
            <tbody>
              @for (vademecumMasVendido of vademecumsMasVendidos; track vademecumMasVendido.id ?? $index) {
                <tr>
                  <td>
                    <div class="product">
                      <div class="product-info">
                        <span class="product-name">{{vademecumMasVendido.x_nombre}}</span>
                        <span class="orders">{{vademecumMasVendido.nombreLaboratorio}} - {{vademecumMasVendido.x_presentacion}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="value">{{vademecumMasVendido.precio | currency:'ARS'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="product-card col-12 col-md-6 col-lg-6">
          <h3 class="titles">Prestaciones mas solicitadas</h3>
          <table class="table">
            <thead>
              <tr>
                <th>PRESTACIÓN</th>
                <th>PRECIO</th>
              </tr>
            </thead>
            <tbody>
              @for (prestacionMasVendida of prestacionesMasVendidas; track prestacionMasVendida.id ?? $index) {
                <tr>
                  <td>
                    <div class="product">
                      <div class="product-info">
                        <span class="product-name">{{prestacionMasVendida.x_descripcion}}</span>
                        <span class="orders">Cant. pedidas: {{prestacionMasVendida.total_pedidas}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="value">{{prestacionMasVendida.n_precio_turno | currency:'ARS'}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="users-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>ÚLTIMOS USUARIOS REGISTRADOS</span>
            <span></span>
          </div>

          <ul class="users-list">
            @for (ultimoClienteRegistrado of ultimosClientesRegistrados; track ultimoClienteRegistrado.id) {
              <li class="users-item cursor-pointer" [routerLink]="['/more-edit-usuario/' + ultimoClienteRegistrado.id]">
                <div class="users-info">
                  <div class="p-2 ms-1" tabindex="0">
                    <img class="title-image-user rounded-circle business-profile" 
                        [src]="ultimoClienteRegistrado.x_img_avatar != null ? apiUri + 'uploads/images/small-' + ultimoClienteRegistrado.x_img_avatar : './assets/img/profesional-init.png'" 
                        (error)="imgFallback($event, './assets/img/profesional-init.png')"
                        style="width: 30px !important;height: 30px !important;border-radius: 40px !important;">
                  </div>
                  <span class="users-name">{{(ultimoClienteRegistrado.x_nombre || ultimoClienteRegistrado.x_apellido) ? ultimoClienteRegistrado.x_nombre + ' ' + ultimoClienteRegistrado.x_apellido : 'Sin datos' }}</span>
                </div>
                <div class="users-stats">
                  <div class="bounce"><strong>{{ultimoClienteRegistrado.d_fecha_creacion | date: 'dd/MM/yyyy'}}</strong></div>
                </div>
              </li>
            }
            <li class="country-item bounce-right cursor-pointer" [routerLink]="['/more-usuarios']">
              <div class="bounce"><strong>Ver todos <i class="bi bi-arrow-right-short"></i></strong></div>
            </li>
          </ul>
        </div>

        <div class="users-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>ÚLTIMOS PRESTADORES REGISTRADOS</span>
            <span></span>
          </div>

          <ul class="users-list">
            @for (ultimoPrestadorRegistrado of ultimosPrestadoresRegistrados; track ultimoPrestadorRegistrado.id) {
              <li class="users-item cursor-pointer" [routerLink]="['/more-edit-prestador/' + ultimoPrestadorRegistrado.id]">
                <div class="users-info">
                  <div class="p-2 ms-1" tabindex="0">
                    <img class="title-image-user rounded-circle business-profile" 
                        [src]="ultimoPrestadorRegistrado.x_img_avatar != null ? apiUri + 'uploads/images/small-' + ultimoPrestadorRegistrado.x_img_avatar : './assets/img/profesional-init.png'" 
                        (error)="imgFallback($event, './assets/img/profesional-init.png')"
                        style="width: 30px !important;height: 30px !important;border-radius: 40px !important;">
                  </div>
                  <span class="users-name">{{(ultimoPrestadorRegistrado.x_nombre || ultimoPrestadorRegistrado.x_apellido) ? ultimoPrestadorRegistrado.x_nombre + ' ' + ultimoPrestadorRegistrado.x_apellido : 'Sin datos' }}</span>
                </div>
                <div class="users-stats">
                  <div class="bounce"><strong>{{ultimoPrestadorRegistrado.d_fecha_creacion | date: 'dd/MM/yyyy'}}</strong></div>
                </div>
              </li>
            }
            <li class="country-item bounce-right cursor-pointer" [routerLink]="['/more-prestadores']">
              <div class="bounce"><strong>Ver todos <i class="bi bi-arrow-right-short"></i></strong></div>
            </li>
          </ul>
        </div>

        <div class="users-card col-12 col-md-6 col-lg-6">
          <div class="card-header">
            <span>ÚLTIMOS COMERCIOS REGISTRADOS</span>
            <span></span>
          </div>

          <ul class="users-list">
            @for (ultimoComercioRegistrado of ultimosComerciosRegistrados; track ultimoComercioRegistrado.id) {
              <li class="users-item cursor-pointer" [routerLink]="['/more-edit-comercio/' + ultimoComercioRegistrado.id]">
                <div class="users-info">
                  <div class="p-2 ms-1" tabindex="0">
                    <img class="title-image-user rounded-circle business-profile" 
                        [src]="ultimoComercioRegistrado.x_img_avatar != null ? apiUri + 'uploads/images/small-' + ultimoComercioRegistrado.x_img_avatar : './assets/img/profesional-init.png'" 
                        (error)="imgFallback($event, './assets/img/profesional-init.png')"
                        style="width: 30px !important;height: 30px !important;border-radius: 40px !important;">
                  </div>
                  <span class="users-name">{{ultimoComercioRegistrado.x_nombre_fantasia ? ultimoComercioRegistrado.x_nombre_fantasia : 'Sin datos' }}</span>
                </div>
                <div class="users-stats">
                  <div class="bounce"><strong>{{ultimoComercioRegistrado.d_fecha_creacion | date: 'dd/MM/yyyy'}}</strong></div>
                </div>
              </li>
            }
            <li class="country-item bounce-right cursor-pointer" [routerLink]="['/more-comercios']">
              <div class="bounce"><strong>Ver todos <i class="bi bi-arrow-right-short"></i></strong></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="card-chart-image">
        <h3 class="titles">Ventas por provincia</h3>
        @for (ordenPorProvincia of ordenesPorProvincias; track ordenPorProvincia.provincia_nombre ?? $index) {
          <div class="chart-container">
            <div class="bar-row">
              <div class="age-label">{{ordenPorProvincia.provincia_nombre}}</div>
              <div class="bar">
                <div class="bar-fill" [ngStyle]="{ 'width': (ordenPorProvincia?.porcentaje_total || 0) + '%' }"></div>
              </div>
              <div class="bar-value">{{ordenPorProvincia.total_ordenes}}</div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- INICIO CLIENTE -->
  @if (id_perfil == 2) {
    <div class="fade-in header-search-home pb-0">
      <div class="row ps-4 pe-4 pt-4 mb-3" style="align-items: center;">
        <div class="col">
          <img src="./assets/img/logo-libresalud-horizontal.png" class="logo-dash pt-2">
        </div>
        <div class="col col-md-5 pe-md-4 home-title-right">
          <div class="col header-right-img me0">
            <a [routerLink]="['/my-account']">
              <img [src]="preview_img_avatar == '' ? './assets/img/user-init.png' : preview_img_avatar" style="width:100%" class="text-end rounded-circle business-profile">
            </a>
          </div>
        </div>
      </div>

      <div class="row ps-0 pe-0" style="align-items: center;">
        <a [routerLink]="['/seleccion-ubicacion-default']">
          <div class="fade-in col tag-row alerts-rows ps-0 pe-0 mb-sm-2 mb-3 mt-3 ms-2 me-2 ms-md-0 me-md-0 ms-lg-0 me-lg-0 ms-xl-0 me-xl-0 cursor-pointer">
            <div class="row align-items-center pt-1 pb-1 p-sm-3">
              <div class="col-auto pe-0"><i class="bi bi-geo-alt dir-icon"></i></div>
              <div class="col alerts-row-text">
                @if (this._usuarioService.ubicacion_default.getValue().x_domicilio) {
                  <div class="dir-row-text-description text-start">{{ (this._usuarioService.ubicacion_default | async)?.x_domicilio }}</div>
                } @else {
                  <div class="dir-row-text-description link-letras text-start">Agrega nueva dirección</div>
                }
              </div>
              <div class="col-auto"><i class="bi bi-chevron-right dir-icon"></i></div>
            </div>
          </div>
        </a>
      </div>

      @if (showNotifications && loading()) {
        <div class="fade-in col col-sm-6 tag-row ms-1 ms-lg-4 me-1 ps-lg-1 ps-4 pe-4 pe-md-0 mb-sm-2 mb-3 mt-4 animation-c7515d" style="border: 1px solid #F2F4F5;min-height: 50px;border-radius: 7px;font-size: 1em;" (click)="subscribeToNotifications()">
          <div class="row align-items-center p-2 p-sm-3">
            <div class="col-auto parpadea"></div>
            <div class="col alerts-row-text">
              <div class="alerts-row-text-title"></div>
              <div class="alerts-row-text-description"></div>
            </div>
            <div class="col-auto"></div>
          </div>
        </div>
      }

      @if (showNotifications && !loading()) {
        <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" (click)="subscribeToNotifications()">
          <div class="row align-items-center p-2 p-sm-3 ms-2 me-2">
            <div class="col-auto parpadea"><i class="bi bi-bell-fill"></i></div>
            <div class="col alerts-row-text">
              <div class="alerts-row-text-title">ACTIVAR LAS NOTIFICACIONES</div>
              <div class="alerts-row-text-description">Para que puedas recibir las novedades</div>
            </div>
            <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
          </div>
        </div>
      }
    </div>
  }

  @if (showFillData) {
    <div class="fade-in header-search-home pb-0">
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" style="height: auto;" [routerLink]="[linkFillData]">
        <div class="row align-items-center p-4 p-sm-5 ms-2 me-2 text-center">
          <div class="col-12 pb-3 banner-title-full-1 d-block d-sm-none">
            <b style="font-size: 1em;">Te damos la bienvenida a Libre Salud</b> <br><br>
            <span style="font-size: 0.8em;">Completá tus datos y comenzá a utilizar Libre Salud</span> <br><br>
            <span class="p-2" style="font-size: 0.8em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-play-circle" style="font-weight: bold;"></i> Completar los datos</span>
          </div>
          <div class="col-12 banner-title-full d-none d-sm-block">
            <b style="font-size: 1.3em;">Te damos la bienvenida a Libre Salud</b> <br><br>
            <span style="font-size: 1em;">Completá tus datos y comenzá a utilizar Libre Salud</span> <br><br> <br>
            <span class="p-2" style="font-size: 1em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-play-circle" style="font-weight: bold;"></i> Completar los datos</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showFillUbicacionesData) {
    <div class="fade-in header-search-home pb-0">
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" style="height: auto;" [routerLink]="['/my-account-ubicaciones']">
        <div class="row align-items-center p-4 p-sm-5 ms-2 me-2 text-center">
          <div class="col-12 pb-3 banner-title-full-1 d-block d-sm-none">
            <b style="font-size: 1em;">Te falta agregar al menos una ubicación</b> <br><br>
            <span style="font-size: 0.8em;">Completá tu/s ubicacion/es y comenzá a utilizar Libre Salud</span> <br><br>
            <span class="p-2" style="font-size: 0.8em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-geo-alt" style="font-weight: bold;"></i> Crear ubicación</span>
          </div>
          <div class="col-12 banner-title-full d-none d-sm-block">
            <b style="font-size: 1.3em;">Te falta agregar al menos una ubicación</b> <br><br>
            <span style="font-size: 1em;">Completá tu/s ubicacion/es y comenzá a utilizar Libre Salud</span> <br><br> <br>
            <span class="p-2" style="font-size: 1em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-geo-alt" style="font-weight: bold;"></i> Crear ubicación</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showFillServiciosData) {
    <div class="fade-in header-search-home pb-0">
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" style="height: auto;" [routerLink]="['/my-account-servicios']">
        <div class="row align-items-center p-4 p-sm-5 ms-2 me-2 text-center">
          <div class="col-12 pb-3 banner-title-full-1 d-block d-sm-none">
            <b style="font-size: 1em;">Te falta agregar al menos un servicio que prestas</b> <br><br>
            <span style="font-size: 0.8em;">Completá tu/s servicio/es y comenzá a utilizar Libre Salud</span> <br><br>
            <span class="p-2" style="font-size: 0.8em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-briefcase" style="font-weight: bold;"></i> Crear servicio</span>
          </div>
          <div class="col-12 banner-title-full d-none d-sm-block">
            <b style="font-size: 1.3em;">Te falta agregar al menos un servicio que prestas</b> <br><br>
            <span style="font-size: 1em;">Completá tu/s servicio/es y comenzá a utilizar Libre Salud</span> <br><br> <br>
            <span class="p-2" style="font-size: 1em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-briefcase" style="font-weight: bold;"></i> Crear servicio</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showFillHorariosData) {
    <div class="fade-in header-search-home pb-0">
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" style="height: auto;" [routerLink]="['/my-account-horarios']">
        <div class="row align-items-center p-4 p-sm-5 ms-2 me-2 text-center">
          <div class="col-12 pb-3 banner-title-full-1 d-block d-sm-none">
            <b style="font-size: 1em;">Te falta completar tus horarios</b> <br><br>
            <span style="font-size: 0.8em;">Completá tus horarios del comercio y comenzá a utilizar Libre Salud</span> <br><br>
            <span class="p-2" style="font-size: 0.8em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-clock" style="font-weight: bold;"></i> Completar horario</span>
          </div>
          <div class="col-12 banner-title-full d-none d-sm-block">
            <b style="font-size: 1.3em;">Te falta completar tus horarios</b> <br><br>
            <span style="font-size: 1em;">Completá tus horarios del comercios y comenzá a utilizar Libre Salud</span> <br><br> <br>
            <span class="p-2" style="font-size: 1em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><i class="bi bi-clock" style="font-weight: bold;"></i> Completar horario</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (id_perfil == 2 && !showFillData && !loading()) {
    @if (showCalificarOrderComercio) {
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-0 mt-3 cursor-pointer">
        <div class="row align-items-center p-2 p-sm-3 ms-2 me-2" [routerLink]="['/pedidos/4']">
          <div class="col-auto parpadea"><i class="bi bi-ui-checks-grid"></i></div>
          <div class="col alerts-row-text">
            <div class="alerts-row-text-title">CALIFICÁ TUS COMPRAS</div>
            <div class="alerts-row-text-description">Para poder ofrecerte mejores servicios</div>
          </div>
          <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
        </div>
      </div>
    }

    @if (showCalificarOrderPrestador) {
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-0 mt-3 cursor-pointer">
        <div class="row align-items-center p-2 p-sm-3 ms-2 me-2" [routerLink]="['/turnos/4']">
          <div class="col-auto parpadea"><i class="bi bi-ui-checks-grid"></i></div>
          <div class="col alerts-row-text">
            <div class="alerts-row-text-title">CALIFICÁ TUS TURNOS</div>
            <div class="alerts-row-text-description">Para poder ofrecerte mejores servicios</div>
          </div>
          <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
        </div>
      </div>
    }
  }

  @if (showFillMercadoPagoData) {
    <div class="fade-in header-search-home pb-0">
      <div class="fade-in col col-12 tag-row ms-0 me-0 alerts-row ps-2 pe-2 ps-md-0 pe-md-0 mb-sm-2 mb-2 mt-2 mt-sm-3 cursor-pointer" style="height: auto;" [routerLink]="['/my-account']">
        <div class="row align-items-center p-4 p-sm-5 ms-2 me-2 text-center">
          <div class="col-12 pb-3 banner-title-full-1 d-block d-sm-none">
            <b style="font-size: 1em;">Te falta vincular mercadopago a tu cuenta</b> <br><br>
            <span style="font-size: 0.8em;">Conecta con mercadopago para poder recibir tus cobros y comenzá a utilizar Libre Salud</span> <br><br>
            <span class="p-2" style="font-size: 0.8em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px"><img class="icon-mercadopago" src="./assets/img/mercado_pago.png" title="Mercado Pago"> Vincular a mercadopago</span>
          </div>
          <div class="col-12 banner-title-full d-none d-sm-block">
            <b style="font-size: 1.3em;">Te falta vincular mercadopago a tu cuenta</b> <br><br>
            <span style="font-size: 1em;">Conecta con mercadopago para poder recibir tus cobros y comenzá a utilizar Libre Salud</span> <br><br> <br>
            <span class="p-2" style="font-size: 1em;font-weight: bold;border: 1px solid #325ea5;border-radius: 50px;"><img class="icon-mercadopago" src="./assets/img/mercado_pago.png" title="Mercado Pago"> Vincular a mercadopago</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (id_perfil == 2 && !showFillData) {
    <div class="row section-app fade-in search-row">
      @if (loading()) {
        <div class="n-categories mb-2 ms-0 ms-lg-0 ms-md-0 ps-md-0 pt-2 pt-md-3 me-0 me-lg-0 me-md-0 pe-md-0 pb-2 justify-content-around">
          <div class="row col-11 col-md-6 col-lg-3 align-items-center banner m-2 me-lg-0 ms-md-1 animation-c7515d">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full-1 d-block d-sm-none"></div>
              <div class="col-auto text-start banner-title-full d-none d-sm-block"></div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block"></div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-11 col-md-6 col-lg-3 align-items-center banner m-2 me-lg-0 ms-md-0 me-md-2 animation-c7515d">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full-1 pe-2"></div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block"></div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-5 col-md-6 col-lg-3 align-items-center banner banner-proximamente m-2 me-lg-0 ms-md-0 animation-c7515d">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full"></div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block"></div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-5 col-md-6 col-lg-3 align-items-center banner banner-proximamente m-2 me-lg-0 ms-md-0 animation-c7515d">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full"></div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block"></div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
        </div>
      } @else {
        <div class="n-categories mb-2 ms-0 ms-lg-0 ms-md-0 ps-md-0 pt-2 pt-md-3 me-0 me-lg-0 me-md-0 pe-md-0 pb-2 justify-content-around">
          <div class="row col-11 col-md-6 col-lg-3 align-items-center banner m-2 me-lg-0 ms-md-0 banner-farmacias" [routerLink]="['/comercio']">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full-1 d-block d-sm-none">Comprá en una farmacia <strong>hasta 30% OFF!</strong></div>
              <div class="col-auto text-start banner-title-full d-none d-sm-block">Farmacias Cercanas</div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block">Hacé tu pedido de farmacia</div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-11 col-md-6 col-lg-3 align-items-center banner m-2 me-lg-0 ms-md-0 me-md-2 banner-urgencias" [routerLink]="['/order-emergencias']">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full-1 pe-2">Emergencias médicas <strong>las 24hs</strong></div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block">Clic acá</div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-5 col-md-6 col-lg-3 align-items-center banner banner-proximamente m-2 me-lg-0 ms-md-0 banner-medicos" [routerLink]="['/especialidad']">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full">Servicios Médicos</div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block">Buscá los mejores médicos</div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
          <div class="row col-5 col-md-6 col-lg-3 align-items-center banner banner-proximamente m-2 me-lg-0 ms-md-0 banner-productos-salud" [routerLink]="['/comercio']">
            <div class="col-8 col-sm-8">
              <div class="col-auto text-start banner-title-full">Productos de Salud</div>
              <div class="col-auto text-start banner-desc-full d-none d-sm-block">Clic Acá</div>
            </div>
            <div class="col-4 col-sm-4 center-text"></div>
          </div>
        </div>
      }
    </div>
  }

  <div>
    <!-- TURNOS -->
    @if (id_perfil == 2) {
      <div class="row section-app fade-in col-12 col-lg-6 ps-0 pe-0 ms-0 me-0 turnos">
        <div class="row row-title align-items-center row-title-float pe-0 me-0 ps-0 ms-0">
          <div class="col-8 row-title-left"><b style="font-weight:300">Mis turnos ({{ordenesPrestador.length}})</b></div>
          <div class="col-4 row-title-right view-all pe-3">
            <a [routerLink]="['/turnos']"><i class="bi bi-arrows-angle-expand"></i></a>
          </div>
        </div>

        <div class="row-cols-12 element-buy mb-3">
          @if (loading()) {
            <div class="col-11 element-buy-item mt-2 fade-in animation-c7515d">
              <div class="col-auto element-buy-item-cols-img nb"></div>
              <div class="col-10 element-buy-item-cols-txt">
                <div class="col element-buy-item-name text-truncate"></div>
                <div class="col element-buy-item-profession"></div>
              </div>
            </div>
          } @else if (ordenesPrestador.length == 0) {
            <div class="col-12 element-buy-item item-empty mt-2" [routerLink]="['/especialidad']">
              <div class="col-auto element-buy-item-cols-img nb">
                <div class="col element-buy-item-image element-buy-item-icon">
                  <i class="bi bi-plus-lg"></i>
                </div>
              </div>
              <div class="col-10 element-buy-item-cols-txt">
                <div class="col element-buy-item-name text-truncate">Contratá un turno</div>
                <div class="col element-buy-item-profession">Parece que no hay reservas de turno. Hacé clic y reservá ahora.</div>
                <hr>
              </div>
            </div>
          } @else {
            <div class="w-100 w-sm-75 d-flex flex-row flex-lg-column">
              @for (orderPrestador of ordenesPrestador; track orderPrestador.id) {
                <div class="col-11 element-buy-item mt-2 fade-in" [routerLink]="orderPrestador.id_estado_orden == 2 ? ['/order-confirm-prestador/' + orderPrestador.id_solicitud] : ['/order-detail-prestador/' + orderPrestador.id]">
                  <div class="col-4 element-buy-item-cols-img">
                    <div class="col element-buy-item-image">
                      <img [src]="orderPrestador.imgAvatarPrestador ? apiUri + 'uploads/images/small-' + orderPrestador.imgAvatarPrestador : './assets/img/profesional-init.png'">
                    </div>
                  </div>
                  <div class="col-8 element-buy-item-cols-txt">
                    <div class="col element-buy-item-name text-truncate">{{orderPrestador.nombrePrestador}}</div>
                    <div class="col element-buy-item-profession text-truncate">{{orderPrestador.nombrePrestacion}}</div>
                    <hr>
                    <div class="col element-buy-item-details">
                      <img [src]="getEstadoImagen(orderPrestador.id_estado_orden!)" style="width:15px;margin-right:2%;">{{orderPrestador.estadoOrden}} | #{{orderPrestador.id}}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (id_perfil == 2 && !showFillData) {
      <div class="row section-app fade-in col-12 col-lg-6 ps-0 pe-0 ms-0 me-0 pedidos justify-content-lg-end">
        <div class="row row-title align-items-center row-title-float pe-0 me-0 ps-0 ms-0">
          <div class="col-8 row-title-left"><b style="font-weight:300">Mis Compras ({{ordenesComercio.length}})</b></div>
          <div class="col-4 row-title-right view-all pe-3"><a [routerLink]="['/pedidos']"><i class="bi bi-arrows-angle-expand"></i></a></div>
        </div>

        <div class="row-cols-12 element-buy turnos mb-1">
          @if (loading()) {
            <div class="col-11 element-buy-item mt-2 fade-in animation-c7515d">
              <div class="col-auto element-buy-item-cols-img nb"></div>
              <div class="col-10 element-buy-item-cols-txt">
                <div class="col element-buy-item-name text-truncate"></div>
                <div class="col element-buy-item-profession"></div>
              </div>
            </div>
          } @else if (ordenesComercio.length == 0) {
            <div class="col-12 element-buy-item item-empty mt-2" [routerLink]="['/comercio']">
              <div class="col-auto element-buy-item-cols-img nb">
                <div class="col element-buy-item-image element-buy-item-icon"><i class="bi bi-plus-lg"></i></div>
              </div>
              <div class="col-10 element-buy-item-cols-txt">
                <div class="col element-buy-item-name">Realizá una compra</div>
                <div class="col element-buy-item-profession">Parece que no hay compras. Hacé clic y realizá una nueva</div>
                <hr>
              </div>
            </div>
          } @else {
            <div class="w-100 w-sm-75 d-flex flex-row flex-lg-column">
              @for (orderComercio of ordenesComercio; track orderComercio.id) {
                <div class="col-11 element-buy-item mt-2 fade-in" [routerLink]="['/order-confirm-comercio/' + orderComercio.id]">
                  <div class="col-4 element-buy-item-cols-img">
                    <div class="col element-buy-item-image">
                      <img [src]="orderComercio.imgAvatarComercio ? apiUri + 'uploads/images/small-' + orderComercio.imgAvatarComercio : './assets/img/commerce-init.png'">
                    </div>
                  </div>
                  <div class="col-8 element-buy-item-cols-txt">
                    <div class="col element-buy-item-name text-truncate">{{orderComercio.nombreComercio}}</div>
                    <div class="col element-buy-item-profession text-truncate">{{orderComercio.direccionComercio}}</div>
                    <hr>
                    <div class="col element-buy-item-details">
                      <img [src]="getEstadoImagen(orderComercio.id_estado_orden!)" style="width:15px;margin-right:2%;"> {{orderComercio.estadoOrden}} | #{{orderComercio.id}}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  @if (id_perfil == 2 && !showFillData && !asociadoCardio() && !loading() && !asociadoCardioLoading()) {
    <div class="fade-in search-row mt-sm-0 pt-sm-0">
      <div class="n-categories col-12 mb-2 pt-0 pt-md-3 pb-2 ps-2 pe-2 ps-lg-2 pe-lg-2 justify-content-around">
        <div class="row col align-items-center banner m-2 ms-2 me-2 ms-md-0 me-md-0 banner-cardio adapt" (click)="openCardioWeb()">
          <div class="col-8 col-sm-8">
            <div class="col-auto text-start banner-title-full-1 d-block">Asegurá tu salud <strong> con Cardio 24hs</strong></div>
          </div>
          <div class="col-4 col-sm-4 center-text"></div>
        </div>
      </div>
    </div>
  } @else if (id_perfil == 2 && !showFillData && asociadoCardio() && !loading() && !asociadoCardioLoading()){
    <div class="fade-in search-row mt-sm-0 pt-sm-0">
      <div class="n-categories col-12 mb-2 pt-0 pt-md-3 pb-2 ps-2 pe-2 ps-lg-2 pe-lg-2 justify-content-around">
        <div class="row col align-items-center banner m-2 ms-2 me-2 ms-md-0 me-md-0 banner-cardio adapt" (click)="openCardioApp()">
          <div class="col-8 col-sm-8">
            <div class="col-auto text-start banner-title-full-1 d-block">¡Descarga la APP de Cardio!</div>
          </div>
          <div class="col-4 col-sm-4 center-text"></div>
        </div>
      </div>
    </div>
  }

  @if (id_perfil == 2 && loading()) {
    <div class="row section-app fade-in search-row mt-sm-0 pt-sm-0">
      <div class="n-categories mb-2 ms-0 ms-lg-2 ms-md-0 pt-0 pt-md-3 me-md-3 pb-2 pe-md-3 justify-content-around">
        <div class="row col-11 col-md-3 align-items-center banner m-2 me-lg-0 ms-md-0 animation-c7515d w-100">
          <div class="col-8 col-sm-8">
            <div class="col-auto text-start banner-title-full-1 d-block d-sm-none"></div>
            <div class="col-auto text-start banner-title-full d-none d-sm-block"></div>
            <div class="col-auto text-start banner-desc-full d-none d-sm-block"></div>
          </div>
          <div class="col-4 col-sm-4 center-text"></div>
        </div>
      </div>
    </div>
  }

  <!-- INICIO COMERCIO -->
  @if (id_perfil == 4 && !showFillData) {
    <div class="fade-in col-12 pedidos ps-0 pe-0 ms-0 me-0 pt-3 mb-3">
      <div class="row row-title pe-0 me-0 ps-0 ms-0 align-items-center row-title-float">
        <div class="col-8 row-title-left"><b style="font-weight:600">Pedidos en curso ({{ordenesComercio.length}})</b></div>
        <div class="col-4 row-title-right view-all pe-3"><a [routerLink]="['/pedidos']">ver todos <i class="bi bi-arrow-right"></i></a></div>
      </div>

      <div class="row-cols-12 element-buy mb-3">
        @if (loading()) {
          <div class="col-11 element-buy-item mt-2 fade-in animation-c7515d">
            <div class="col-auto element-buy-item-cols-img nb"></div>
            <div class="col-10 element-buy-item-cols-txt">
              <div class="col element-buy-item-name text-truncate"></div>
              <div class="col element-buy-item-profession"></div>
            </div>
          </div>
        } @else if (ordenesComercio.length == 0) {
          <div class="col-12 element-buy-item item-empty mt-2 d-flex align-items-center justify-content-center min-vh-50">
            <div class="text-center">
              <div class="element-buy-item-name text-truncate">Aún no tienes pedidos en curso</div>
              <div class="element-buy-item-profession">Esperamos que pronto ingrese uno nuevo.</div>
            </div>
          </div>
        } @else {
          <div class="w-100 w-sm-75 d-flex flex-row flex-lg-column">
            @for (orderComercio of ordenesComercio; track orderComercio.id) {
              <div class="col-11 element-buy-item mt-2 fade-in" [routerLink]="['/order-response-comercio/' + orderComercio.id]">
                <div class="col-4 element-buy-item-cols-img">
                  <div class="col element-buy-item-image">
                    <img [src]="orderComercio.imgAvatarCliente ? apiUri + 'uploads/images/small-' + orderComercio.imgAvatarCliente : './assets/img/profesional-init.png'">
                  </div>
                </div>
                <div class="col-8 element-buy-item-cols-txt">
                  <div class="col element-buy-item-name text-truncate">{{orderComercio.nombreCliente}}</div>
                  <div class="col element-buy-item-profession text-truncate">{{orderComercio.d_date_create | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                  <hr>
                  <div class="d-flex align-items-center">
                    <div class="col element-buy-item-details element-buy-item-details-add align-items-center">
                      <img src="./assets/img/info-ayuda.png" style="width:11px;margin-right:2%;"> #{{orderComercio.id}}
                    </div>
                    <div class="col element-buy-item-details element-buy-item-details-add align-items-center">
                      @if (orderComercio.b_envio_domicilio) {
                        <span><i class="bi bi-truck icons-detail pe-1" style="font-size: 12px;"></i> Envío </span>
                      } @else {
                        <span><i class="bi bi-shop icons-detail pe-1" style="font-size: 12px;"></i> Retiro </span>
                      }
                    </div>
                    <div class="col element-buy-item-details element-buy-item-details-add align-items-center">
                      @if (orderComercio.b_pago_efectivo) {
                        <span><i class="bi bi-cash-coin icons-detail pe-1" style="font-size: 11px;"></i> Efvo </span>
                      } @else {
                        <span><img src="./assets/img/mercado_pago.png" title="Mercado Pago" class="icon-mercadopago pe-1 mb-1" style="width:15px;">MP</span>
                      }
                    </div>
                    <div class="col element-buy-item-details element-buy-item-details-add align-items-center" style="font-size: 0.5em;">
                      <img [src]="getEstadoImagen(orderComercio.id_estado_orden!)" style="width:15px;margin-right:2%;"> {{ orderComercio.estadoOrden }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- INICIO PRESTADOR -->
  @if (id_perfil == 3 && !showFillData) {
    <div class="fade-in pe-0 pedidos ps-0 pe-0 ms-0 me-0 pt-3 mb-3">
      <div class="row row-title pe-0 me-0 ps-0 ms-0 align-items-center row-title-float">
        <div class="col-8 row-title-left"><b style="font-weight:600">Próximos turnos ({{ordenesPrestadorDelDia.length}})</b></div>
        <div class="col-4 row-title-right view-all pe-3"><a [routerLink]="['/turnos']">ver todos <i class="bi bi-arrow-right"></i></a></div>
      </div>

      <div class="row-cols-12 element-buy mb-3">
        @if (loading()) {
          <div class="col-11 element-buy-item mt-2 fade-in animation-c7515d">
            <div class="col-auto element-buy-item-cols-img nb"></div>
            <div class="col-10 element-buy-item-cols-txt">
              <div class="col element-buy-item-name text-truncate"></div>
              <div class="col element-buy-item-profession"></div>
            </div>
          </div>
        } @else if (ordenesPrestadorDelDia.length == 0) {
          <div class="col-12 element-buy-item item-empty mt-2 d-flex align-items-center justify-content-center min-vh-50">
            <div class="text-center">
              <div class="element-buy-item-name text-truncate">Aún no tienes turnos en curso</div>
              <div class="element-buy-item-profession">Esperamos que pronto ingrese uno nuevo.</div>
            </div>
          </div>
        } @else {
          <div class="w-100 w-sm-75 d-flex flex-row flex-lg-column">
            @for (orderPrestador of ordenesPrestadorDelDia; track orderPrestador.id) {
              <div class="col-11 element-buy-item mt-2 fade-in" [routerLink]="['/order-detail-prestador/' + orderPrestador.id]">
                <div class="col-4 element-buy-item-cols-img">
                  <div class="col element-buy-item-image">
                    <img [src]="orderPrestador.imgAvatarCliente ? apiUri + 'uploads/images/small-' + orderPrestador.imgAvatarCliente : './assets/img/profesional-init.png'">
                  </div>
                </div>
                <div class="col-8 element-buy-item-cols-txt">
                  <div class="col element-buy-item-name text-truncate">{{orderPrestador.nombreCliente}}</div>
                  <div class="col element-buy-item-profession text-truncate">{{orderPrestador.nombreEspecialidad ? orderPrestador.nombreEspecialidad : orderPrestador.nombrePrestacion ? orderPrestador.nombrePrestacion : 'No especifica'}}</div>
                  <hr>
                  <div class="d-flex align-items-center">
                    <div class="col element-buy-item-details"><img src="./assets/img/info-ayuda.png" style="width:11px;margin-right:2%;"> #{{orderPrestador.id }} </div>
                    <div class="col element-buy-item-details"><img [src]="getEstadoImagen(orderPrestador.id_estado_orden!)" style="width:15px;margin-right:2%;"> {{orderPrestador.estadoOrden}} </div>
                    <div class="col element-buy-item-details"><img src="./assets/img/clock.png" style="width:11px;margin-right:2%;"> {{orderPrestador.d_fecha_turno | date: 'dd/MM/yyyy HH:mm'}}hs. </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <div class="row row-title pe-0 me-0 ps-0 ms-0 align-items-center row-title-float">
        <div class="col-8 row-title-left"><b style="font-weight:600">Turnos para aprobar ({{ordenesPrestadorAprobar.length}})</b></div>
        <div class="col-4 row-title-right view-all pe-3"><a [routerLink]="['/turnos']">ver todos <i class="bi bi-arrow-right"></i></a></div>
      </div>

      <div class="row-cols-12 element-buy mb-3">
        @if (loading()) {
          <div class="col-11 element-buy-item mt-2 fade-in animation-c7515d">
            <div class="col-auto element-buy-item-cols-img nb"></div>
            <div class="col-10 element-buy-item-cols-txt">
              <div class="col element-buy-item-name text-truncate"></div>
              <div class="col element-buy-item-profession"></div>
            </div>
          </div>
        } @else if (ordenesPrestadorAprobar.length == 0) {
          <div class="col-12 element-buy-item item-empty mt-2 d-flex align-items-center justify-content-center min-vh-50">
            <div class="text-center">
              <div class="element-buy-item-name text-truncate">Aún no tienes turnos para aprobar</div>
              <div class="element-buy-item-profession">Esperamos que pronto ingrese uno nuevo.</div>
            </div>
          </div>
        } @else {
          <div class="w-100 w-sm-75 d-flex flex-row flex-lg-column">
            @for (orderPrestador of ordenesPrestadorAprobar; track orderPrestador.id) {
              <div class="col-11 element-buy-item mt-2 fade-in" [routerLink]="orderPrestador.id_estado_orden == 1 ? ['/order-response-prestador/' + orderPrestador.id] : orderPrestador.id_estado_orden == 2 ? ['/order-response-prestador/' + orderPrestador.id] : ['/order-detail-prestador/' + orderPrestador.id]">
                <div class="col-4 element-buy-item-cols-img">
                  <div class="col element-buy-item-image">
                    <img [src]="orderPrestador.imgAvatarCliente ? apiUri + 'uploads/images/small-' + orderPrestador.imgAvatarCliente : './assets/img/profesional-init.png'">
                  </div>
                </div>
                <div class="col-8 element-buy-item-cols-txt">
                  <div class="col element-buy-item-name text-truncate">{{orderPrestador.nombreCliente}}</div>
                  <div class="col element-buy-item-profession text-truncate">{{orderPrestador.nombreEspecialidad ? orderPrestador.nombreEspecialidad : orderPrestador.nombrePrestacion ? orderPrestador.nombrePrestacion : 'No especifica'}}</div>
                  <hr>
                  <div class="d-flex align-items-center">
                    <div class="col-3 element-buy-item-details"><img src="./assets/img/info-ayuda.png" style="width:11px;margin-right:2%;"> #{{orderPrestador.id }} </div>
                    <div class="col-6 element-buy-item-details"><img [src]="getEstadoImagen(orderPrestador.id_estado_orden!)" style="width:15px;margin-right:2%;"> {{orderPrestador.estadoOrden}} </div>
                    <div class="col-3 element-buy-item-details">
                      <img src="./assets/img/clock.png" style="width:11px;margin-right:2%;">
                      @if (orderPrestador.b_manana) { <span>Mañana</span> }
                      @if ((orderPrestador.b_manana && orderPrestador.b_tarde) || (orderPrestador.b_manana && orderPrestador.b_noche)) { <span> | </span> }
                      @if (orderPrestador.b_tarde) { <span>Tarde</span> }
                      @if (orderPrestador.b_tarde && orderPrestador.b_noche) { <span> | </span> }
                      @if (orderPrestador.b_noche) { <span>Noche</span> }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <!-- END body show-->
</div>